import { t as __t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import "./user-contract-access.css";
import { useDispatch } from "react-redux";
import {
	callSearchUser,
	callResetPassword,
	callUnlockAccount,
	callChangeDeviceNoti,
	callUpdateToAgent,
} from "../../../api/callcenters/service";
import {
	callSearchAgentInfo,
	callGetAllProvince,
	callGetDistrict,
	callEditUserManagement,
} from "../../../api/settings/service";
import {
	callAttachContractToUser,
	callDetachContractFromUser,
	callGetUserContracts,
	callSearchContractsForUser,
} from "../../../api/contract/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter";
import CustomPagination from "../../../components/paginations";
import ConfirmModal from "../../../components/modal";
import DataAutoComplete from "../../../components/auto-complete";
import SwalAlert from "../../../components/common/alert";
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import { dateToString, getLaosDateTime, handleGetCookie } from "../../../utils/commonUtil";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";
import moment from "moment";
import colors from "../../../utils/colors";
import SmartTable from "../../../components/common/table-component";

const SUCCESS_CODE = "00000";

const EMPTY_EDIT_USER_FORM = {
	userId: null,
	firstName: "",
	lastName: "",
	phone: "",
	provinceId: "",
	districtId: "",
	village: "",
	status: "",
};

const Index = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const [request, setRequest] = useState({
		page: 1,
		maxResult: 10,
		keyword: "",
		modifiedCode: "",
		modifiedName: "",
	});

	const [customerList, setCustomerList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(0);

	// Online/session status
	const [statusNow, setStatusNow] = useState(getLaosDateTime());
	const [showUserDetailModal, setShowUserDetailModal] = useState(false);
	const [detailUser, setDetailUser] = useState(null);
	const lastLoadedRequestRef = useRef({
		page: 1,
		maxResult: 10,
		keyword: "",
	});

	// Update user to agent
	const [show, setShow] = useState(false);
	const [agentData, setAgentData] = useState(null);
	const [agent, setAgent] = useState([]);
	const [userId, setUserId] = useState(null);

	// Contract access
	const [showContractModal, setShowContractModal] = useState(false);
	const [selectedUser, setSelectedUser] = useState(null);
	const [userContracts, setUserContracts] = useState([]);
	const [availableContracts, setAvailableContracts] = useState([]);
	const [contractKeyword, setContractKeyword] = useState("");
	const [assignedLoading, setAssignedLoading] = useState(false);
	const [searchLoading, setSearchLoading] = useState(false);
	const [contractActionId, setContractActionId] = useState(null);

	// Edit user
	const [showEditUserModal, setShowEditUserModal] = useState(false);
	const [editUserLoading, setEditUserLoading] = useState(false);
	const [editUserErrors, setEditUserErrors] = useState({});
	const [editUserForm, setEditUserForm] = useState(
		EMPTY_EDIT_USER_FORM
	);

	// Province and district
	const [provinceList, setProvinceList] = useState([]);
	const [districtList, setDistrictList] = useState([]);
	const [provinceLoading, setProvinceLoading] = useState(false);
	const [districtLoading, setDistrictLoading] = useState(false);

	useEffect(() => {
		loadData();

		const authData = handleGetCookie("auth");

		if (authData?.user?.userId) {
			setRequest((prev) => ({
				...prev,
				modifiedCode: authData.user.userId,
				modifiedName: `${authData.user.firstName || ""} ${authData.user.lastName || ""
					}`.trim(),
			}));
		}
	}, [request.page, request.maxResult]);

	// useEffect(() => {
	// 	const timer = window.setInterval(() => {
	// 		setStatusNow(getLaosDateTime());
	// 		loadData({
	// 			silent: true,
	// 			query: lastLoadedRequestRef.current,
	// 		});
	// 	}, 60000);

	// 	return () => window.clearInterval(timer);
	// }, []);

	useEffect(() => {
		if (!detailUser?.userId) return;

		const updatedUser = customerList.find(
			(item) => item.userId === detailUser.userId
		);

		if (updatedUser && updatedUser !== detailUser) {
			setDetailUser(updatedUser);
		}
	}, [customerList, detailUser?.userId]);

	// ============================================================
	// COMMON HELPERS
	// ============================================================

	const getResponseList = (rsp) => {
		const result =
			rsp?.payload?.data?.result ??
			rsp?.payload?.data ??
			[];

		return Array.isArray(result) ? result : [];
	};

	const getProvinceId = (item) =>
		item?.provinceId ?? item?.id ?? "";

	const getProvinceName = (item) =>
		item?.provinceName ??
		item?.provinceNameLa ??
		item?.nameLa ??
		item?.name_la ??
		item?.name ??
		"-";

	const getDistrictId = (item) =>
		item?.districtId ?? item?.id ?? "";

	const getDistrictName = (item) =>
		item?.districtName ??
		item?.districtNameLa ??
		item?.nameLa ??
		item?.name_la ??
		item?.name ??
		"-";

	const getSessionState = (item) => {
		if (!item?.tokenStart || !item?.tokenEnd) {
			return {
				isOnline: false,
				lastOnlineMinutes:
					item?.lastOnlineMinutes ?? null,
			};
		}

		const start = moment.utc(item.tokenStart);
		const end = moment.utc(item.tokenEnd);
		const now = moment.utc(statusNow);
		if (!start.isValid() || !end.isValid()) {
			return {
				isOnline: Number(item?.isOnline) === 1,
				lastOnlineMinutes:
					item?.lastOnlineMinutes ?? null,
			};
		}

		const isOnline =
			(now.valueOf() >= start.valueOf() &&
				now.valueOf() <= end.valueOf())
		return {
			isOnline,
			lastOnlineMinutes: isOnline
				? 0
				: Math.max(0, now.diff(end, "minutes")),
		};
	};

	const renderOnlineStatus = (item) => {
		const { isOnline } = getSessionState(item);
		console.log("renderOnlineStatus", item, isOnline)
		return (
			<span
				className={`account-online-status ${isOnline ? "online" : "offline"}`}
			>
				<span className="account-online-dot"></span>
				{isOnline
					? t("callcenter.customerService.online")
					: t("callcenter.customerService.offline")}
			</span>
		);
	};

	const renderLastOnline = (item) => {
		const { isOnline, lastOnlineMinutes } = getSessionState(item);

		if (isOnline) {
			return (
				<span className="account-last-online active">
					{t("callcenter.customerService.onlineNow")}
				</span>
			);
		}
		console.log("lastOnlineMinutes", lastOnlineMinutes)
		if (lastOnlineMinutes === null || lastOnlineMinutes === undefined) {
			return <span className="text-muted">-</span>;
		}

		return (
			<span className="account-last-online">
				{lastOnlineMinutes > 60 ? "ຫຼາຍຊົວໂມງກ່ອນ" : t("callcenter.customerService.minutesAgo", {
					count: lastOnlineMinutes,
				})}
			</span>
		);
	};

	const formatSessionDate = (value) =>
		value ? dateToString(value, "DD/MM/YYYY HH:mm:ss") : "-";

	const openUserDetail = (item) => {
		setDetailUser(item);
		setShowUserDetailModal(true);
	};

	// ============================================================
	// USER LIST
	// ============================================================

	const loadData = async (e = null) => {

		try {
			if (e) {
				// ເກັບ page / page size ລ່າສຸດໄວ້ ເພື່ອ restore ຕອນກັບຄືນ
				setRequest((prev) => ({ ...prev, ...e }));
			}
			let data = {
				page: request.page,
				maxResult: request.maxResult,
				keyword: request.keyword.trim(),
			};
			if (e) {
				data = { ...data, ...e }
			}

			const rsp = await dispatch(
				callSearchUser({ ...data})
			);

			if (rsp?.payload?.responseCode === SUCCESS_CODE) {
				setCustomerList(rsp.payload?.data?.result || []);
				setTotalPages(rsp.payload?.data?.totalPages || 1);
				setTotalRecord(rsp.payload?.data?.totalRecords || 0);
			} else {
				setCustomerList([]);
				setTotalPages(1);
				setTotalRecord(0);
			}
		} catch (error) {
			console.log("Load user error:", error);
			setCustomerList([]);
			setTotalPages(1);
			setTotalRecord(0);
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({
				...prev,
				page: pageNumber,
			}));
		}
	};

	const handleChange = (e) => {
		setRequest((prev) => ({
			...prev,
			keyword: e.target.value,
		}));
	};

	const onSearch = async (e) => {
		e.preventDefault();

		if (request.page !== 1) {
			setRequest((prev) => ({
				...prev,
				page: 1,
			}));
		} else {
			await loadData();
		}
	};

	// ============================================================
	// PROVINCE AND DISTRICT
	// ============================================================

	const loadProvinceOptions = async () => {
		setProvinceLoading(true);

		try {
			const rsp = await dispatch(callGetAllProvince());
			if (rsp?.payload?.responseCode === SUCCESS_CODE) {
				setProvinceList(getResponseList(rsp));
			} else {
				setProvinceList([]);
			}
		} catch (error) {
			console.log("Load province error:", error);
			setProvinceList([]);
		} finally {
			setProvinceLoading(false);
		}
	};

	const loadDistrictOptions = async (provinceId) => {
		if (!provinceId) {
			setDistrictList([]);
			return;
		}

		setDistrictLoading(true);

		try {
			const rs = await dispatch(callGetDistrict({ provinceId: provinceId }));
			if (rs?.payload?.responseCode === SUCCESS_CODE) {
				setDistrictList(getResponseList(rs));
			} else {
				setDistrictList([]);
			}
		} catch (error) {
			console.log("Load district error:", error);
			setDistrictList([]);
		} finally {
			setDistrictLoading(false);
		}
	};

	// ============================================================
	// EDIT USER
	// ============================================================

	const openEditUserModal = async (item) => {
		const provinceId = item?.provinceId ?? "";
		const districtId = item?.districtId ?? "";

		setEditUserErrors({});
		setDistrictList([]);
		console.log("item", item)
		setEditUserForm({
			userId: item?.userId || null,
			firstName: item?.firstName || "",
			lastName: item?.lastName || "",
			phone: item?.phone || item?.username || "",
			userTypeId: item?.userTypeId || null,
			roleStaff: item?.roleStaff || null,
			provinceId,
			districtId,
			village: item?.village || "",
			status: item?.status,
		});

		setShowEditUserModal(true);

		await loadProvinceOptions();

		if (provinceId) {
			await loadDistrictOptions(provinceId);
		}
	};

	const closeEditUserModal = () => {
		if (editUserLoading) return;

		setShowEditUserModal(false);
		setEditUserErrors({});
		setEditUserForm(EMPTY_EDIT_USER_FORM);
		setDistrictList([]);
	};

	const handleEditUserChange = (e) => {
		const { name, value } = e.target;

		setEditUserForm((prev) => ({
			...prev,
			[name]: value,
			...(name === "provinceId"
				? {
					districtId: "",
				}
				: {}),
		}));

		setEditUserErrors((prev) => ({
			...prev,
			[name]: "",
			...(name === "provinceId"
				? {
					districtId: "",
				}
				: {}),
		}));

		if (name === "provinceId") {
			setDistrictList([]);
			if (value) {
				loadDistrictOptions(value);
			}
		}
	};

	const validateEditUser = () => {
		const errors = {};
		const phone = editUserForm.phone.trim();

		if (!editUserForm.firstName.trim()) {
			errors.firstName = __t("uiText.text112");
		}

		if (!phone) {
			errors.phone = __t("uiText.text113");
		} else if (!/^[0-9+\-\s]{7,20}$/.test(phone)) {
			errors.phone = __t("uiText.text114");
		}

		if (!editUserForm.provinceId) {
			errors.provinceId = __t("uiText.text115");
		}

		if (!editUserForm.districtId) {
			errors.districtId = __t("uiText.text116");
		}

		if (!editUserForm.village.trim()) {
			errors.village = __t("uiText.text117");
		}
		if (!editUserForm.status.trim()) {
			errors.status = __t("uiText.text118");
		}

		setEditUserErrors(errors);

		return Object.keys(errors).length === 0;
	};

	const handleUpdateUser = async () => {
		if (editUserLoading || !validateEditUser()) return;

		setEditUserLoading(true);

		try {
			const payload = {
				userId: editUserForm.userId,
				firstName: editUserForm.firstName.trim(),
				lastName: editUserForm.lastName.trim(),
				phone: editUserForm.phone.trim(),
				systemName: "web",
				provinceId: Number(editUserForm.provinceId),
				districtId: Number(editUserForm.districtId),
				userTypeId: editUserForm.userTypeId,
				village: editUserForm.village.trim(),
				roleStaff: editUserForm.roleStaff,
				modifiedCode: request.modifiedCode,
				modifiedName: request.modifiedName,
				status: editUserForm.status,
			};

			const rsp = await dispatch(callEditUserManagement(payload));

			if (rsp?.payload?.responseCode === SUCCESS_CODE) {
				setShowEditUserModal(false);
				setEditUserForm(EMPTY_EDIT_USER_FORM);
				setEditUserErrors({});
				setDistrictList([]);

				await loadData();

				Swal.fire({
					icon: "success",
					title: __t("uiText.text119"),
					text: __t("uiText.text120"),
					timer: 1600,
					showConfirmButton: false,
				});
			} else {
				Swal.fire({
					icon: "error",
					title: __t("uiText.text121"),
					text:
						rsp?.payload?.responseDescription ||
						__t("uiText.text122"),
					confirmButtonColor: colors.confirmMessage,
				});
			}
		} catch (error) {
			Swal.fire({
				icon: "error",
				title: __t("uiText.text123"),
				text:
					error?.message ||
					__t("uiText.text124"),
				confirmButtonColor: colors.confirmMessage,
			});
		} finally {
			setEditUserLoading(false);
		}
	};

	// ============================================================
	// RESET PASSWORD
	// ============================================================

	const handleResetPassword = (id) => {
		Swal.fire({
			title: t(
				"callcenter.customerService.confirm.titleResetPassword"
			),
			text: t(
				"callcenter.customerService.confirm.messageResetPassword"
			),
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t("confirm"),
			cancelButtonText: t("cancel"),
		}).then(async (result) => {
			if (!result.isConfirmed) return;

			try {
				const rsp = await dispatch(
					callResetPassword({
						userId: id,
						modifiedCode: request.modifiedCode,
						modifiedName: request.modifiedName,
					})
				);

				if (rsp?.payload?.responseCode === SUCCESS_CODE) {
					Swal.fire({
						icon: "success",
						title: t(
							"callcenter.customerService.confirm.successResetPassword"
						),
						confirmButtonColor: colors.confirmMessage,
						confirmButtonText: t("close"),
					}).then(() => loadData());
				}
			} catch (error) {
				Swal.fire(
					__t("uiText.text023"),
					__t("uiText.text024"),
					"error"
				);
			}
		});
	};

	// ============================================================
	// UNLOCK ACCOUNT
	// ============================================================

	const handleUnlock = (id) => {
		Swal.fire({
			title: t(
				"callcenter.customerService.confirm.titleUnlockAccount"
			),
			text: t(
				"callcenter.customerService.confirm.messageUnlockAccount"
			),
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t("confirm"),
			cancelButtonText: t("cancel"),
		}).then(async (result) => {
			if (!result.isConfirmed) return;

			try {
				const rsp = await dispatch(
					callUnlockAccount({
						userId: id,
						modifiedCode: request.modifiedCode,
						modifiedName: request.modifiedName,
					})
				);

				if (rsp?.payload?.responseCode === SUCCESS_CODE) {
					Swal.fire({
						icon: "success",
						title: t(
							"callcenter.customerService.confirm.successUnlockAccount"
						),
						confirmButtonColor: colors.confirmMessage,
						confirmButtonText: t("close"),
					}).then(() => loadData());
				}
			} catch (error) {
				Swal.fire(
					__t("uiText.text023"),
					__t("uiText.text024"),
					"error"
				);
			}
		});
	};

	// ============================================================
	// CHANGE DEVICE
	// ============================================================

	const handleChangeDevice = (id) => {
		Swal.fire({
			title: t(
				"callcenter.customerService.confirm.titleChangeDevice"
			),
			text: t(
				"callcenter.customerService.confirm.messageChangeDevice"
			),
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t("confirm"),
			cancelButtonText: t("cancel"),
		}).then(async (result) => {
			if (!result.isConfirmed) return;

			try {
				const rsp = await dispatch(
					callChangeDeviceNoti({
						userId: id,
						modifiedCode: request.modifiedCode,
						modifiedName: request.modifiedName,
					})
				);

				if (rsp?.payload?.responseCode === SUCCESS_CODE) {
					Swal.fire({
						icon: "success",
						title: t(
							"callcenter.customerService.confirm.successChangeDevice"
						),
						confirmButtonColor: colors.confirmMessage,
						confirmButtonText: t("close"),
					}).then(() => loadData());
				}
			} catch (error) {
				Swal.fire(
					__t("uiText.text023"),
					__t("uiText.text024"),
					"error"
				);
			}
		});
	};

	// ============================================================
	// AGENT
	// ============================================================

	const loadDataAgent = async (value) => {
		const data = value?.id
			? {
				keyword: null,
				page: 1,
				maxResult: 1,
				agentId: value.id,
				type: null,
			}
			: {
				keyword: value,
				page: 1,
				maxResult: 10,
				agentId: null,
				type: null,
			};

		const rsp = await dispatch(callSearchAgentInfo(data));

		if (rsp?.payload?.responseCode === SUCCESS_CODE) {
			setAgent(rsp.payload?.data?.result || []);
		} else {
			setAgent([]);
		}
	};

	const onSelect = (item) => {
		setAgentData(item?.agentId || null);
	};

	const handleUpdateToAgent = () => {
		if (!agentData) {
			SwalAlert.error(
				t("error"),
				t("errors.agentIdNotfound")
			);
			return;
		}

		SwalAlert.confirm(
			t(
				"callcenter.customerService.confirm.titleUpdateAgent"
			),
			t("callcenter.customerService.confirm.msgUpdateAgent"),
			async () => {
				const rsp = await dispatch(
					callUpdateToAgent({
						userId,
						agentId: agentData,
					})
				);

				if (rsp?.payload?.responseCode === SUCCESS_CODE) {
					setShow(false);
					setAgentData(null);
					setAgent([]);
					loadData();
				}
			}
		);
	};

	// ============================================================
	// CONTRACT ACCESS
	// ============================================================

	const openContractManager = async (item) => {
		setSelectedUser(item);
		setContractKeyword("");
		setShowContractModal(true);

		await Promise.all([
			loadUserContracts(item.userId),
			searchAvailableContracts(item.userId, ""),
		]);
	};

	const loadUserContracts = async (
		targetUserId = selectedUser?.userId
	) => {
		if (!targetUserId) return;

		setAssignedLoading(true);

		try {
			const rsp = await dispatch(
				callGetUserContracts({
					userId: targetUserId,
					page: 1,
					maxResult: 100,
					keyword: "",
				})
			);

			if (rsp?.payload?.responseCode === SUCCESS_CODE) {
				setUserContracts(rsp.payload?.data?.result || []);
			} else {
				setUserContracts([]);
			}
		} finally {
			setAssignedLoading(false);
		}
	};

	const searchAvailableContracts = async (
		targetUserId = selectedUser?.userId,
		keyword = contractKeyword
	) => {
		if (!targetUserId) return;

		setSearchLoading(true);

		try {
			const rsp = await dispatch(
				callSearchContractsForUser({
					userId: targetUserId,
					page: 1,
					maxResult: 50,
					keyword: keyword.trim(),
				})
			);

			if (rsp?.payload?.responseCode === SUCCESS_CODE) {
				setAvailableContracts(
					rsp.payload?.data?.result || []
				);
			} else {
				setAvailableContracts([]);
			}
		} finally {
			setSearchLoading(false);
		}
	};

	const attachContract = async (contractId) => {
		if (!selectedUser?.userId || contractActionId) return;

		setContractActionId(contractId);

		try {
			const rsp = await dispatch(
				callAttachContractToUser({
					userId: selectedUser.userId,
					contractId,
				})
			);

			if (rsp?.payload?.responseCode === SUCCESS_CODE) {
				await Promise.all([
					loadUserContracts(selectedUser.userId),
					searchAvailableContracts(
						selectedUser.userId,
						contractKeyword
					),
				]);

				Swal.fire({
					icon: "success",
					title: __t("uiText.text125"),
					timer: 1200,
					showConfirmButton: false,
				});
			} else {
				Swal.fire(
					__t("uiText.text126"),
					rsp?.payload?.responseDescription ||
					__t("uiText.text127"),
					"error"
				);
			}
		} finally {
			setContractActionId(null);
		}
	};

	const detachContract = async (contractId) => {
		const result = await Swal.fire({
			title: __t("uiText.text128"),
			text:
				__t("uiText.text129"),
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: __t("uiText.text130"),
			cancelButtonText: __t("uiText.text016"),
			reverseButtons: true,
		});

		if (!result.isConfirmed) return;

		setContractActionId(contractId);

		try {
			const rsp = await dispatch(
				callDetachContractFromUser({
					userId: selectedUser.userId,
					contractId,
				})
			);

			if (rsp?.payload?.responseCode === SUCCESS_CODE) {
				await Promise.all([
					loadUserContracts(selectedUser.userId),
					searchAvailableContracts(
						selectedUser.userId,
						contractKeyword
					),
				]);

				Swal.fire({
					icon: "success",
					title: __t("uiText.text131"),
					timer: 1200,
					showConfirmButton: false,
				});
			}
		} finally {
			setContractActionId(null);
		}
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>

			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />

			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>
							{t(
								"menu.callcenter.changePassDevice"
							)}
						</h4>
					</div>

					{/* Search */}
					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<form onSubmit={onSearch}>
											<div className="row">
												<div className="col-md-3">
													<div className="form-group">
														<label>
															{t(
																"search.keyword"
															)}
														</label>

														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={`${t(
																"search.keyword"
															)}...`}
															value={
																request.keyword
															}
															autoComplete="off"
															onChange={
																handleChange
															}
														/>
													</div>
												</div>

												<div className="col-auto auto-button">
													<label>&nbsp;</label>

													<button
														type="submit"
														className="theme-btn btn-style-one w-100"
													>
														<i className="fas fa-search"></i>
														&nbsp;
														{t(
															"button.search"
														)}
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Table */}
					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										{/* <RecordsTableFilter
											totalRecord={totalRecord}
											perPage={
												request.maxResult
											}
											onChange={(e) =>
												setRequest(
													(prev) => ({
														...prev,
														maxResult:
															Number(
																e
																	.target
																	.value
															),
														page: 1,
													})
												)
											}
										/> */}

										<SmartTable
											columns={[
												{
													labelKey: "callcenter.customerService.firstName",
													key: "firstName",
													render: (val, row) => (
														<button
															type="button"
															className="account-user-name-btn"
															onClick={() => openUserDetail(row)}
															title={t("callcenter.customerService.viewUserDetail")}
														>
															<i className="fas fa-user-circle"></i>
															<span>{val || "-"}</span>
														</button>
													),
												},
												{ labelKey: "callcenter.customerService.lastName", key: "lastName" },
												{
													labelKey: "callcenter.customerService.onlineStatus",
													key: "isOnline",
													render: (_, row) => renderOnlineStatus(row),
												},
												{
													labelKey: "callcenter.customerService.lastOnline",
													key: "lastOnlineMinutes",
													render: (_, row) => renderLastOnline(row),
												},
												{ labelKey: "callcenter.customerService.agentCode", key: "agentCode" },
												{ labelKey: "callcenter.customerService.phone", key: "phone", render: (val, row) => val || row.username || '-' },
												{ labelKey: "callcenter.customerService.status", key: "status", render: (val) => val === 1 ? <span className="badge bg-success">{t('status.active')}</span> : val === 2 ? <span className="badge bg-danger">{t('status.lock')}</span> : <span className="badge bg-secondary">{t('status.inActive')}</span> },
												{ labelKey: "callcenter.customerService.provinceName", key: "provinceName" },
												{ labelKey: "callcenter.customerService.districtName", key: "districtName" },
												{ labelKey: "callcenter.customerService.village", key: "village" },
												{ labelKey: "callcenter.customerService.lastLogin", key: "lastLogin", render: (val) => formatSessionDate(val) },
											]}
											data={{ result: customerList, totalRecords: totalRecord, totalPages }}
											rowKey="userId"
											onLazyLoad={loadData}
											actions={(item) => (<div>
												<button type="button" className="btn btn-warning btn-sm" title={__t("uiText.text132")} onClick={() => openEditUserModal(item)}><i className="fas fa-user-edit text-white"></i></button>
												&nbsp;
												<button type="button" className="btn btn-primary btn-sm" title={__t("uiText.text376")} onClick={() => handleResetPassword(item.userId)}><i className="fas fa-key"></i></button>
												&nbsp;
												{item.status === 2 && <><button type="button" className="btn btn-success btn-sm" title="Unlock" onClick={() => handleUnlock(item.userId)}><i className="fas fa-user-lock"></i></button>&nbsp;</>}
												<button type="button" className="btn btn-info btn-sm" title={__t("uiText.text377")} onClick={() => handleChangeDevice(item.userId)}><i className="fas fa-bell text-white"></i></button>
												&nbsp;
												<button type="button" className="btn btn-contract-access btn-sm" title={__t("uiText.text133")} disabled={!!item.agentId} onClick={() => openContractManager(item)}><i className="fas fa-file-contract text-white"></i></button>
												&nbsp;
												<button type="button" className="btn btn-success btn-sm" title={__t("uiText.text378")} onClick={() => { setShow(true); setUserId(item.userId); setAgentData(null); }}><i className="fas fa-blog text-white"></i></button>
											</div>)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* User detail modal */}
				<ConfirmModal
					show={showUserDetailModal}
					onHide={() => {
						setShowUserDetailModal(false);
						setDetailUser(null);
					}}
					title={t("callcenter.customerService.userDetail")}
					size="lg"
					centered
					hideConfirm={true}
					cancelText={__t("uiText.text009")}
				>
					{detailUser && (
						<div className="account-detail-modal">
							<div className="account-detail-hero">
								<div className="account-detail-avatar">
									{(detailUser.firstName || "U").charAt(0).toUpperCase()}
								</div>

								<div className="account-detail-heading">
									<div className="account-detail-title-row">
										<h5>
											{detailUser.firstName || "-"}{" "}
											{detailUser.lastName || ""}
										</h5>
										{renderOnlineStatus(detailUser)}
									</div>
									<div className="account-detail-subtitle">
										<span>
											<i className="fas fa-id-card"></i>
											ID: {detailUser.userId || "-"}
										</span>
										<span>
											<i className="fas fa-phone"></i>
											{detailUser.phone || detailUser.username || "-"}
										</span>
									</div>
								</div>
							</div>

							<div className="account-detail-section">
								<div className="account-detail-section-title">
									<i className="fas fa-user"></i>
									<span>{t("callcenter.customerService.userInformation")}</span>
								</div>

								<div className="account-detail-grid">
									<div className="account-detail-item">
										<small>{t("callcenter.customerService.username")}</small>
										<strong>{detailUser.username || "-"}</strong>
									</div>
									<div className="account-detail-item">
										<small>{t("callcenter.customerService.agentCode")}</small>
										<strong>{detailUser.agentCode || "-"}</strong>
									</div>
									<div className="account-detail-item">
										<small>{t("callcenter.customerService.accountStatus")}</small>
										<strong>
											{detailUser.status === 1
												? t("status.active")
												: detailUser.status === 2
													? t("status.lock")
													: t("status.inActive")}
										</strong>
									</div>
									<div className="account-detail-item">
										<small>{t("callcenter.customerService.userType")}</small>
										<strong>{detailUser.userTypeId || "-"}</strong>
									</div>
									<div className="account-detail-item">
										<small>{t("callcenter.customerService.provinceName")}</small>
										<strong>{detailUser.provinceName || "-"}</strong>
									</div>
									<div className="account-detail-item">
										<small>{t("callcenter.customerService.districtName")}</small>
										<strong>{detailUser.districtName || "-"}</strong>
									</div>
									<div className="account-detail-item account-detail-item-wide">
										<small>{t("callcenter.customerService.village")}</small>
										<strong>{detailUser.village || "-"}</strong>
									</div>
								</div>
							</div>

							<div className="account-detail-section session">
								<div className="account-detail-section-title">
									<i className="fas fa-clock"></i>
									<span>{t("callcenter.customerService.sessionInformation")}</span>
								</div>

								<div className="account-session-cards">
									<div className="account-session-card">
										<div className="account-session-icon start">
											<i className="fas fa-play"></i>
										</div>
										<div>
											<small>{t("callcenter.customerService.tokenStart")}</small>
											<strong>{formatSessionDate(detailUser.tokenStart)}</strong>
										</div>
									</div>

									<div className="account-session-card">
										<div className="account-session-icon end">
											<i className="fas fa-stop"></i>
										</div>
										<div>
											<small>{t("callcenter.customerService.tokenEnd")}</small>
											<strong>{formatSessionDate(detailUser.tokenEnd)}</strong>
										</div>
									</div>

									<div className="account-session-card">
										<div className="account-session-icon time">
											<i className="fas fa-hourglass-half"></i>
										</div>
										<div>
											<small>{t("callcenter.customerService.tokenTime")}</small>
											<strong>
												{detailUser.tokenTime
													? `${detailUser.tokenTime} ${t("callcenter.customerService.minutes")}`
													: "-"}
											</strong>
										</div>
									</div>

									<div className="account-session-card">
										<div className="account-session-icon login">
											<i className="fas fa-sign-in-alt"></i>
										</div>
										<div>
											<small>{t("callcenter.customerService.lastLogin")}</small>
											<strong>{formatSessionDate(detailUser.lastLogin)}</strong>
										</div>
									</div>
								</div>

								<div className="account-last-online-box">
									<span>{t("callcenter.customerService.lastOnline")}</span>
									<strong>{renderLastOnline(detailUser)}</strong>
								</div>
							</div>
						</div>
					)}
				</ConfirmModal>

				{/* Edit user modal */}
				<ConfirmModal
					show={showEditUserModal}
					onHide={closeEditUserModal}
					title={__t("uiText.text134")}
					size="lg"
					centered
					onConfirm={handleUpdateUser}
					confirmText={
						editUserLoading
							? __t("uiText.text111")
							: __t("uiText.text135")
					}
					cancelText={__t("uiText.text016")}
				>
					<div className="edit-user-modal">
						<div className="edit-user-banner">
							<div className="edit-user-avatar">
								{(editUserForm.firstName || "U")
									.charAt(0)
									.toUpperCase()}
							</div>

							<div className="edit-user-banner-info">
								<h5>
									{editUserForm.firstName ||
										"User"}{" "}
									{editUserForm.lastName}
								</h5>

								<div className="edit-user-banner-meta">
									<span>
										<i className="fas fa-id-card"></i>
										{__t("uiText.text379")}{" "}
										{editUserForm.userId || "-"}
									</span>

									<span>
										<i className="fas fa-phone"></i>
										{editUserForm.phone || "-"}
									</span>
								</div>
							</div>

							<div className="edit-user-banner-icon">
								<i className="fas fa-user-edit"></i>
							</div>
						</div>

						<Form
							className="edit-user-form"
							onSubmit={(e) => {
								e.preventDefault();
								handleUpdateUser();
							}}
						>
							<div className="edit-user-section">
								<div className="edit-section-heading">
									<div className="edit-section-icon">
										<i className="fas fa-user"></i>
									</div>

									<div>
										<h6>{__t("uiText.text136")}</h6>
										<p>
											{__t("uiText.text137")}</p>
									</div>
								</div>

								<div className="row">
									<div className="col-md-6 mb-3">
										<Form.Group>
											<Form.Label>
												{__t("uiText.text138")}<span className="required-star">
													*
												</span>
											</Form.Label>

											<div className="edit-control-wrapper">
												<i className="fas fa-user"></i>

												<Form.Control
													type="text"
													name="firstName"
													value={
														editUserForm.firstName
													}
													placeholder={__t("uiText.text139")}
													autoComplete="off"
													disabled={
														editUserLoading
													}
													isInvalid={
														!!editUserErrors.firstName
													}
													onChange={
														handleEditUserChange
													}
												/>
											</div>

											{editUserErrors.firstName && (
												<div className="edit-error-message">
													<i className="fas fa-exclamation-circle"></i>
													{
														editUserErrors.firstName
													}
												</div>
											)}
										</Form.Group>
									</div>

									<div className="col-md-6 mb-3">
										<Form.Group>
											<Form.Label>
												{__t("uiText.text140")}</Form.Label>

											<div className="edit-control-wrapper">
												<i className="fas fa-user-tag"></i>

												<Form.Control
													type="text"
													name="lastName"
													value={
														editUserForm.lastName
													}
													placeholder={__t("uiText.text141")}
													autoComplete="off"
													disabled={
														editUserLoading
													}
													onChange={
														handleEditUserChange
													}
												/>
											</div>
										</Form.Group>
									</div>

									<div className="col-md-12">
										<Form.Group>
											<Form.Label>
												{__t("uiText.text142")}<span className="required-star">
													*
												</span>
											</Form.Label>

											<div className="edit-control-wrapper">
												<i className="fas fa-phone"></i>

												<Form.Control
													type="text"
													inputMode="tel"
													name="phone"
													value={
														editUserForm.phone
													}
													placeholder={__t("uiText.text143")}
													autoComplete="off"
													disabled={
														editUserLoading
													}
													isInvalid={
														!!editUserErrors.phone
													}
													onChange={
														handleEditUserChange
													}
												/>
											</div>

											{editUserErrors.phone && (
												<div className="edit-error-message">
													<i className="fas fa-exclamation-circle"></i>
													{
														editUserErrors.phone
													}
												</div>
											)}
										</Form.Group>
									</div>
								</div>
							</div>

							<div className="edit-user-section location-section">
								<div className="edit-section-heading">
									<div className="edit-section-icon location">
										<i className="fas fa-map-marker-alt"></i>
									</div>

									<div>
										<h6>{__t("uiText.text144")}</h6>
										<p>
											{__t("uiText.text145")}</p>
									</div>
								</div>

								<div className="row">
									<div className="col-md-6 mb-3">
										<Form.Group>
											<Form.Label>
												{__t("uiText.text146")}<span className="required-star">
													*
												</span>
											</Form.Label>

											<div className="edit-control-wrapper select-wrapper">
												<i className="fas fa-map"></i>

												<Form.Select
													name="provinceId"
													value={
														editUserForm.provinceId
													}
													disabled={
														provinceLoading ||
														editUserLoading
													}
													isInvalid={
														!!editUserErrors.provinceId
													}
													onChange={
														handleEditUserChange
													}
												>
													<option value="">
														{provinceLoading
															? __t("uiText.text147")
															: __t("uiText.text148")}
													</option>

													{provinceList.map(
														(
															province,
															index
														) => (
															<option
																key={
																	getProvinceId(
																		province
																	) ||
																	`province-${index}`
																}
																value={getProvinceId(
																	province
																)}
															>
																{getProvinceName(
																	province
																)}
															</option>
														)
													)}
												</Form.Select>

												{provinceLoading && (
													<i className="fas fa-spinner fa-spin select-loading-icon"></i>
												)}
											</div>

											{editUserErrors.provinceId && (
												<div className="edit-error-message">
													<i className="fas fa-exclamation-circle"></i>
													{
														editUserErrors.provinceId
													}
												</div>
											)}
										</Form.Group>
									</div>

									<div className="col-md-6 mb-3">
										<Form.Group>
											<Form.Label>
												{__t("uiText.text149")}<span className="required-star">
													*
												</span>
											</Form.Label>

											<div className="edit-control-wrapper select-wrapper">
												<i className="fas fa-city"></i>

												<Form.Select
													name="districtId"
													value={
														editUserForm.districtId
													}
													disabled={
														!editUserForm.provinceId ||
														districtLoading ||
														editUserLoading
													}
													isInvalid={
														!!editUserErrors.districtId
													}
													onChange={
														handleEditUserChange
													}
												>
													<option value="">
														{!editUserForm.provinceId
															? __t("uiText.text150")
															: districtLoading
																? __t("uiText.text151")
																: __t("uiText.text152")}
													</option>

													{districtList.map(
														(
															district,
															index
														) => (
															<option
																key={
																	getDistrictId(
																		district
																	) ||
																	`district-${index}`
																}
																value={getDistrictId(
																	district
																)}
															>
																{getDistrictName(
																	district
																)}
															</option>
														)
													)}
												</Form.Select>

												{districtLoading && (
													<i className="fas fa-spinner fa-spin select-loading-icon"></i>
												)}
											</div>

											{editUserErrors.districtId && (
												<div className="edit-error-message">
													<i className="fas fa-exclamation-circle"></i>
													{
														editUserErrors.districtId
													}
												</div>
											)}
										</Form.Group>
									</div>

									<div className="col-md-6 mb-3">
										<Form.Group>
											<Form.Label>
												{__t("uiText.text153")}<span className="required-star">
													*
												</span>
											</Form.Label>

											<div className="edit-control-wrapper">
												<i className="fas fa-home"></i>

												<Form.Control
													type="text"
													name="village"
													value={
														editUserForm.village
													}
													placeholder={__t("uiText.text154")}
													autoComplete="off"
													disabled={
														editUserLoading
													}
													isInvalid={
														!!editUserErrors.village
													}
													onChange={
														handleEditUserChange
													}
												/>
											</div>

											{editUserErrors.village && (
												<div className="edit-error-message">
													<i className="fas fa-exclamation-circle"></i>
													{
														editUserErrors.village
													}
												</div>
											)}
										</Form.Group>
									</div>
									<div className="col-md-6 mb-3">
										<Form.Group>
											<Form.Label>
												{__t("uiText.text155")}<span className="required-star">
													*
												</span>
											</Form.Label>

											<div className="edit-control-wrapper select-wrapper">
												<i className="fas fa-info-circle"></i>

												<Form.Select
													name="status"
													value={
														editUserForm.status
													}
													disabled={
														editUserLoading
													}
													isInvalid={
														!!editUserErrors.status
													}
													onChange={
														handleEditUserChange
													}
												>
													<option value="1">
														{t(
															"status.active"
														)}
													</option>
													<option value="2">
														{t(
															"status.lock"
														)}
													</option>
													<option value="0">
														{t(
															"status.inActive"
														)}
													</option>

												</Form.Select>
											</div>

											{editUserErrors.status && (
												<div className="edit-error-message">
													<i className="fas fa-exclamation-circle"></i>
													{
														editUserErrors.status
													}
												</div>
											)}
										</Form.Group>
									</div>
								</div>
							</div>

							{editUserLoading && (
								<div className="edit-saving-box">
									<div className="edit-saving-spinner">
										<i className="fas fa-spinner fa-spin"></i>
									</div>

									<div>
										<strong>
											{__t("uiText.text156")}</strong>
										<span>
											{__t("uiText.text157")}</span>
									</div>
								</div>
							)}
						</Form>
					</div>
				</ConfirmModal>

				{/* Contract access modal */}
				<ConfirmModal
					show={showContractModal}
					onHide={() => {
						setShowContractModal(false);
						setSelectedUser(null);
						setUserContracts([]);
						setAvailableContracts([]);
						setContractKeyword("");
					}}
					title={__t("uiText.text158")}
					size="xl"
					centered
					hideConfirm={true}
					cancelText={__t("uiText.text009")}
				>
					<div className="contract-access-manager">
						<div className="contract-user-summary">
							<div className="contract-user-avatar">
								{(selectedUser?.firstName || "U")
									.charAt(0)
									.toUpperCase()}
							</div>

							<div className="contract-user-detail">
								<div className="contract-user-name">
									{selectedUser?.firstName || "-"}{" "}
									{selectedUser?.lastName || ""}
								</div>

								<div className="contract-user-meta">
									<span>
										<i className="fas fa-id-card"></i>{" "}
										{__t("uiText.text379")}{" "}
										{selectedUser?.userId || "-"}
									</span>

									<span>
										<i className="fas fa-phone"></i>{" "}
										{selectedUser?.phone ||
											selectedUser?.username ||
											"-"}
									</span>
								</div>
							</div>

							<div className="contract-count-box">
								<span>{userContracts.length}</span>
								<small>
									{__t("uiText.text159")}</small>
							</div>
						</div>

						<div className="row g-4">
							<div className="col-lg-6">
								<div className="contract-panel assigned-panel">
									<div className="contract-panel-header">
										<div>
											<h5>
												<i className="fas fa-shield-alt"></i>{" "}
												{__t("uiText.text160")}</h5>
											<p>
												{__t("uiText.text161")}</p>
										</div>

										<button
											type="button"
											className="icon-refresh-btn"
											disabled={
												assignedLoading
											}
											onClick={() =>
												loadUserContracts(
													selectedUser?.userId
												)
											}
										>
											<i
												className={`fas fa-sync-alt ${assignedLoading
													? "fa-spin"
													: ""
													}`}
											></i>
										</button>
									</div>

									<div className="contract-list-container">
										{assignedLoading ? (
											<div className="contract-state">
												<i className="fas fa-circle-notch fa-spin"></i>
												<span>
													{__t("uiText.text162")}</span>
											</div>
										) : userContracts.length >
											0 ? (
											userContracts.map(
												(contract) => (
													<div
														className="contract-card assigned"
														key={
															contract.id
														}
													>
														<div className="contract-card-icon">
															<i className="fas fa-file-signature"></i>
														</div>

														<div className="contract-card-content">
															<strong>
																{contract.contractNumber ||
																	"-"}
															</strong>

															<span>
																{contract.customerName ||
																	__t("uiText.text163")}
															</span>

															<small>
																<i className="far fa-calendar-alt"></i>{" "}
																{contract.signedDate
																	? moment(
																		contract.signedDate
																	).format(
																		"DD/MM/YYYY"
																	)
																	: "-"}
															</small>
														</div>

														<button
															type="button"
															className="contract-action-btn remove"
															disabled={
																contractActionId !==
																null
															}
															title={__t("uiText.text164")}
															onClick={() =>
																detachContract(
																	contract.id
																)
															}
														>
															{contractActionId ===
																contract.id ? (
																<i className="fas fa-spinner fa-spin"></i>
															) : (
																<i className="fas fa-unlink"></i>
															)}
														</button>
													</div>
												)
											)
										) : (
											<div className="contract-state empty">
												<div className="empty-icon">
													<i className="far fa-folder-open"></i>
												</div>
												<strong>
													{__t("uiText.text165")}</strong>
												<span>
													{__t("uiText.text166")}</span>
											</div>
										)}
									</div>
								</div>
							</div>

							<div className="col-lg-6">
								<div className="contract-panel search-panel">
									<div className="contract-panel-header">
										<div>
											<h5>
												<i className="fas fa-search"></i>{" "}
												{__t("uiText.text167")}</h5>
											<p>
												{__t("uiText.text168")}</p>
										</div>
									</div>

									<div className="contract-search-box">
										<i className="fas fa-search"></i>

										<input
											type="text"
											value={contractKeyword}
											placeholder={__t("uiText.text169")}
											onChange={(e) =>
												setContractKeyword(
													e.target.value
												)
											}
											onKeyDown={(e) => {
												if (
													e.key ===
													"Enter"
												) {
													e.preventDefault();
													searchAvailableContracts(
														selectedUser?.userId,
														contractKeyword
													);
												}
											}}
										/>

										{contractKeyword && (
											<button
												type="button"
												className="clear-search"
												onClick={() => {
													setContractKeyword(
														""
													);
													searchAvailableContracts(
														selectedUser?.userId,
														""
													);
												}}
											>
												<i className="fas fa-times"></i>
											</button>
										)}

										<button
											type="button"
											className="search-contract-btn"
											disabled={searchLoading}
											onClick={() =>
												searchAvailableContracts(
													selectedUser?.userId,
													contractKeyword
												)
											}
										>
											{searchLoading ? (
												<i className="fas fa-spinner fa-spin"></i>
											) : (
												__t("uiText.text170")
											)}
										</button>
									</div>

									<div className="contract-list-container search-results">
										{searchLoading ? (
											<div className="contract-state">
												<i className="fas fa-circle-notch fa-spin"></i>
												<span>
													{__t("uiText.text171")}</span>
											</div>
										) : availableContracts.length >
											0 ? (
											availableContracts.map(
												(contract) => (
													<div
														className={`contract-card ${contract.alreadyAdded
															? "already-added"
															: ""
															}`}
														key={
															contract.id
														}
													>
														<div className="contract-card-icon">
															<i className="fas fa-file-contract"></i>
														</div>

														<div className="contract-card-content">
															<strong>
																{contract.contractNumber ||
																	"-"}
															</strong>
															<span>
																{contract.customerName ||
																	__t("uiText.text163")}
															</span>

															{contract.username && (
																<small>
																	<i className="fas fa-phone"></i>{" "}
																	{
																		contract.username
																	}
																</small>
															)}
														</div>

														{contract.alreadyAdded ? (
															<span className="added-badge">
																<i className="fas fa-check"></i>{" "}
																{__t("uiText.text172")}</span>
														) : (
															<button
																type="button"
																className="contract-action-btn add"
																disabled={
																	contractActionId !==
																	null
																}
																onClick={() =>
																	attachContract(
																		contract.id
																	)
																}
															>
																{contractActionId ===
																	contract.id ? (
																	<i className="fas fa-spinner fa-spin"></i>
																) : (
																	<>
																		<i className="fas fa-plus"></i>
																		<span>
																			{__t("uiText.text173")}</span>
																	</>
																)}
															</button>
														)}
													</div>
												)
											)
										) : (
											<div className="contract-state empty">
												<div className="empty-icon">
													<i className="fas fa-search"></i>
												</div>
												<strong>
													{__t("uiText.text174")}</strong>
												<span>
													{__t("uiText.text175")}</span>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</ConfirmModal>

				{/* Update agent modal */}
				<ConfirmModal
					show={show}
					onHide={() => {
						setShow(false);
						setAgentData(null);
						setAgent([]);
					}}
					title={t(
						"callcenter.customerService.updateToAgent"
					)}
					size="md"
					centered
					onConfirm={handleUpdateToAgent}
				>
					<div>
						<p className="mb-2">
							{__t("uiText.text176")}</p>

						<div className="col-md-12 form-group">
							<label>
								{t("contracts.life.agentCode")}
								<span className="text-danger">
									*
								</span>
							</label>

							<DataAutoComplete
								label="firstName"
								id="agentCode"
								data={agent}
								autoSelect={true}
								placeholder={t(
									"contract.keyword"
								)}
								handleChange={loadDataAgent}
								onSelect={onSelect}
							/>
						</div>
					</div>
				</ConfirmModal>
			</section>

			<CopyrightFooter />
		</div>
	);
};

export default Index;
